// @flow
import {
    INJECT_HOMEBASES,
    IS_FETCH_HOMEBASE_IN_PROGRESS
} from 'common/constants/actionTypes';
import { homebase } from 'common/middleware/api';
import { injectError } from './error';
import { ApiError } from 'common/modules/api';
import { type Dispatch } from 'redux';
import { type HomebaseModelType } from 'common/models/flow/Homebase';

const HomebaseIncludes = Object.freeze({
    CROSS_DOCK: 'CROSS_DOCK'
});

export const pollHomebasesByClientId = (...params) => {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                fetchHomebasesByClientId(...params, {
                    onSuccess: resolve,
                    onFailure: reject
                })
            );
        });
    };
};

export const fetchHomebasesByClientId = (
    clientId: string,
    {
        onSuccess,
        onFailure,
        includeCrossDock = false
    }: {
        onSuccess?: (homebases: Array<HomebaseModelType>) => void,
        onFailure?: (error: Error) => void,
        includeCrossDock?: boolean
    } = {}
): ((dispatch: Dispatch<$FixMe>) => Promise<void>) => {
    return (dispatch: Dispatch<$FixMe>) => {
        const params: { clientId: string, include?: string } = {
            clientId
        };

        if (includeCrossDock) {
            params.include = HomebaseIncludes.CROSS_DOCK;
        }

        dispatch(setIsFetchHomebaseInProgress(clientId, true));
        return homebase
            .fetch(params)
            .then((homebases: Array<HomebaseModelType>) => {
                onSuccess?.(homebase);
                dispatch(injectHomebases(homebases, { clientId }));
                dispatch(setIsFetchHomebaseInProgress(clientId, false));
                return;
            })
            .catch(error => {
                onFailure?.(error);
                if (error instanceof ApiError) {
                    dispatch(injectError(error));
                    return;
                }
                throw error;
            });
    };
};

type InjectHomebasesAction = {
    params: { clientId: string },
    response: Array<HomebaseModelType>,
    type: 'INJECT_HOMEBASES'
};

export const injectHomebases = (
    homebases: Array<HomebaseModelType>,
    params: { clientId: string }
): InjectHomebasesAction => {
    return {
        type: INJECT_HOMEBASES,
        response: homebases,
        params
    };
};

type FetchingHomebasesAction = {
    params: { clientId: string },
    response: boolean,
    type: 'IS_FETCH_HOMEBASE_IN_PROGRESS'
};

export const setIsFetchHomebaseInProgress = (
    clientId: string,
    isFetchHomebaseInProgress: boolean
): FetchingHomebasesAction => {
    return {
        type: IS_FETCH_HOMEBASE_IN_PROGRESS,
        response: isFetchHomebaseInProgress,
        params: {
            clientId
        }
    };
};
